module.exports = __webpack_public_path__ + "img/TIFF_picture_icon@2x.e721ad7c.png";